import React from 'react'

type RouteType = {
  path: string
  redirect?: string
  component?: React.ComponentType<any>
}

export const routes: RouteType[] = [
  { path: '/challenge', component: React.lazy(() => import('@views/Challenge')) },
  { path: '/deposit', component: React.lazy(() => import('@views/Deposit')) },
  { path: '/details', component: React.lazy(() => import('@views/CardDetails')) },
  { path: '/withdrawal', component: React.lazy(() => import('@views/Withdrawal')) }
]
